module.exports = __webpack_public_path__ + "./images/map-grid-bg.svg";